module.exports = __webpack_public_path__ + "img/order-list-h.52ebef93.svg";